import { z } from 'zod';

const PasswordSchema = z.string().min(6, 'Senhas devem ter pelo menos 6 caracteres').max(100);

export const RegisterFormSchema = z
  .object({
    name: z.string().min(2, 'Nome deve ter pelo menos 2 caracteres').max(100),
    email: z.string().email('Email inválido'),
    password1: PasswordSchema,
    password2: PasswordSchema,
  })
  .refine(data => data.password1 === data.password2, {
    message: 'Senhas não coincidem',
    path: ['password2'],
  });

export const LoginFormSchema = z.object({
  email: z.string().email('Email inválido'),
  password: PasswordSchema,
});

export const UserSchema = z.object({
  name: z.string().min(2, 'Nome deve ter pelo menos 2 caracteres').max(100),
  email: z.string().email('Email inválido'),
  token: z.string().min(10),
});

export const DeleteAccountFormSchema = z.object({
  token: z.string({ required_error: 'Token inválido.' }),
});

export type RegisterForm = z.infer<typeof RegisterFormSchema>;
export type LoginForm = z.infer<typeof LoginFormSchema>;
export type User = z.infer<typeof UserSchema>;
